export default __webpack_public_path__ + "static/media/chat_aja.c08cd8ba.svg";